import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { QueryClient, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';

export type ApiFnReturnType<TApiFn extends (...args: any) => Promise<any>> = Awaited<ReturnType<TApiFn>>;

export type QueryConfig<TQueryFn extends (...args: any) => any> = Omit<ReturnType<TQueryFn>, 'queryKey' | 'queryFn'>;

export type QueryOptions<TData, TError = Error> = Omit<UseQueryOptions<TData, TError>, 'queryKey' | 'queryFn'>;

export type MutationOptions<TData = void, TError = Error, TVariables = void> = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;

export type MutationConfig<TMutationFn extends (...args: any) => Promise<any>> = UseMutationOptions<
  ApiFnReturnType<TMutationFn>,
  Error,
  Parameters<TMutationFn>[0]
>;

export const queryPersister = createAsyncStoragePersister({
  storage: window.sessionStorage,
  key: 'myTalquin:app:cache'
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60,
      gcTime: 1000 * 60 * 60 * 24 // 24 hours
    }
  }
});
